import { atom } from 'recoil';

export const beaconState = atom({
  key: 'beaconState',
  default: null,
});
